import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, 
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, 
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          },
        }, 
        {
          path: '/product/whatsApp',
          name: 'whatsApp',
          component: resolve => require(['@/view/WhatsAppService'], resolve),
          meta: {
            
          }
        },
        {
          path: '/product/OtpService',
          name: 'OtpService',
          component: resolve => require(['@/view/OtpService'], resolve),
          meta: {}
        },
        {
          path: '/product/marketingSms',
          name: 'marketingSms',
          component: resolve => require(['@/view/MarketingSms'], resolve),
          meta: {}
        },
        {
          path: '/product/numberFiltering',
          name: 'numberFiltering',
          component: resolve => require(['@/view/NumberFiltering'], resolve),
          meta: {}
        },
        
        {
          path: '/product/predictiveDiale',
          name: 'predictiveDiale',
          component: resolve => require(['@/view/PredictiveDialer'], resolve),
          meta: {}
        },
        {
          path: '/product/phone',
          name: 'phone',
          component: resolve => require(['@/view/PhoneService'], resolve),
          meta: {}
        },
        {
          path: '/product/ivr',
          name: 'ivr',
          component: resolve => require(['@/view/IvrService'], resolve),
          meta: {}
        },
        {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '关于我们'
          }
        },
        {
          path: '/contactSale',
          name: 'contactSale',
          component: resolve => require(['@/view/ContactSale'], resolve),
          meta: {
            title: '联系销售'
          }
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // 如果是通过浏览器的前进/后退按钮导航，则保持原来的滚动位置
    if (savedPosition) {
      return savedPosition;
    } else {
      // 否则滚动到新页面的顶部
      return { x: 0, y: 0 };
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js